export class ExcelValidation{
    name:string;
    count: number;
    type: string;
    valid?: boolean;
}